'use strict';

exports.__esModule = true;
exports.default = AccessDenied;
function AccessDenied(message) {
  this.name = 'AccessDenied';
  this.message = message;
}

AccessDenied.prototype = Error.prototype;